export const ClientOnboardingSteps = [
  'timezoneLanguage',
  'basicInfo',
  'about',
  'trainingLevel',
  'fitnessGoals',
  'healthIssues',
  'pendingQuestionnaires',
] as const;

export type ClientOnboardingStepsType = typeof ClientOnboardingSteps;

export const ClientFitnessOnboardingSteps = [
  'trainingLevel',
  'fitnessGoals',
  'healthIssues',
] as const;

export type ClientFitnessOnboardingStepsType =
  typeof ClientFitnessOnboardingSteps;
